import { MainBase } from "../MainBase.js";
import jQuery from "jquery";

export type ButtonToggler = (state: boolean) => void;

export type Action = (name: string, buttonToggler?: ButtonToggler, pressed_key?: string) => void;

export type ActionEntry = {
    text?: string,
    keys: string[],
    action: Action,
    identifier: string, // name of Action is copied automatically to name of ActionEntry
    active: boolean
}

export class ActionManager {

    actions: { [actionIdentifier: string]: ActionEntry } = { };

    keyEntries: { [key: string]: ActionEntry[] } = {};

    buttons: { [actionIdentifier: string]: JQuery<HTMLElement>[] } = {};

    constructor(private $mainElement: JQuery<HTMLElement>, private main: MainBase){

    }

    public init(){

        let $element:JQuery<any> = this.$mainElement;
        
        if($element == null) $element = jQuery(document);

        let that = this;
        $element.on("keydown", function (event: JQuery.KeyDownEvent) { 
            if(event != null){
                that.executeKeyDownEvent(event); 
            }
        });

    }

    trigger(actionIdentifier: string) {
        let ae = this.actions[actionIdentifier];
        if(ae != null){
            ae.action(actionIdentifier, null, "");
        }
    }


    public registerAction(identifier: string, keys: string[], action: Action, text: string = "", button?: JQuery<HTMLElement>){
        let ae: ActionEntry = {
            action: action,
            identifier: identifier,
            keys: keys,
            text: text,
            active: true
        };

        this.actions[identifier] = ae;

        for(let key of keys){
            if(this.keyEntries[key.toLowerCase()] == null){
                this.keyEntries[key.toLowerCase()] = [];
            }
            this.keyEntries[key.toLowerCase()].push(ae);
        }

        if(button != null){
            if(this.buttons[identifier] == null){
                this.buttons[identifier] = [];
            }
            this.buttons[identifier].push(button);

            let t = text;
            if(keys.length > 0){
                t += " [" + keys.join(", ") + "]";
            }

            button.attr("title", t);

            button.on('mousedown', () => {
                if(ae.active){
                    action(identifier, null, "mousedown");
                }
            });

        }

    }

    public isActive(actionIdentifier: string): boolean {

        let ae: ActionEntry = this.actions[actionIdentifier];
        
        if(ae == null) return false;

        return ae.active;
    
    }

    public setActive(actionIdentifier: string, active: boolean){
        let ae: ActionEntry = this.actions[actionIdentifier];
        
        if(ae != null){
            ae.active = active;
        }

        let buttons = this.buttons[actionIdentifier];
        if(buttons != null){
            for(let button of buttons){
                if(active){
                    button.addClass('jo_active');
                } else {
                    button.removeClass('jo_active');
                }
            }
        }

    }

    public executeKeyDownEvent(event: JQuery.KeyDownEvent) {

        if(document.activeElement.tagName.toLowerCase() == "input"){
            return;
        }

        if (event.keyCode <= 18 && event.keyCode >= 16) {
            return; // ctrl, alt, shift
        }

        let key: string = "";

        if (event.ctrlKey) {
            key += "ctrl+";
        }

        if (event.shiftKey) {
            key += "shift+";
        }

        if (event.altKey) {
            key += "alt+";
        }

        if(event.key != null){
            key += event.key.toLowerCase();
        }

        let actionEntries = this.keyEntries[key];

        if(actionEntries != null){
            for(let actionEntry of actionEntries){
                if (actionEntry.active) {
                    event.stopPropagation();
                    event.preventDefault();
                    actionEntry.action(actionEntry.identifier, null, key);
                    break;
                }
            }
        }


    }


}